// Validação client-side da chave de acesso de NF-e (44 caracteres + DV módulo 11).
// Espelho do app/utils/validacao_chave_nfe.py do backend — manter os dois
// algoritmos sincronizados. CNPJ alfanumérico (NT Conjunta 2025.001): letras só
// nas posições 7 a 18 (o CNPJ sem os 2 DV); DV com ASCII − 48 (utils/cnpj.js).

import { RE_CHAVE, dvChave, limparChave } from './cnpj';

export function limparChaveNfe(input) {
  if (input == null) return '';
  return limparChave(input);
}

export function validarChaveNfe(input) {
  const chave = limparChaveNfe(input);

  if (chave.length !== 44) {
    return { valida: false, chave, erro: 'Chave precisa ter 44 dígitos' };
  }
  if (!RE_CHAVE.test(chave)) {
    return { valida: false, chave,
      erro: 'Chave inválida: só o CNPJ (posições 7 a 20, sem os 2 últimos dígitos) pode ter letras' };
  }

  const dvCalculado = dvChave(chave.slice(0, 43));
  const dvInformado = chave.slice(43);
  if (dvCalculado !== dvInformado) {
    return {
      valida: false,
      chave,
      erro: `Dígito verificador inválido (esperado ${dvCalculado}, recebido ${dvInformado})`,
    };
  }

  return { valida: true, chave, erro: null };
}
